import debounce from "lodash.debounce";

window.HomeFilter = new (function () {
  const submitForm = debounce(() => document.getElementById("main_filter_form")?.requestSubmit?.(), 100);


  const form = document.getElementById("main_filter_form")
  if (form) {
    form.addEventListener("doSubmit", submitForm);
  }

  this.bindFilters = () => {
    $(".filter-form select:not(#subject_teacher--filter):not(#filter_academic_year)").change(submitForm);
    $(".filter-form x-select:not(#subject_teacher--filter):not(#filter_academic_year)").change(submitForm);
    $(".filter-form input:not([type=checkbox])").on("input change", debounce(submitForm, 1000));
    $(".filter-form input[type=checkbox]").on("change", submitForm);
    $(".filter-form input[type=radio]").on("change", submitForm);
    $(".filter-form .bi-x").on("click", submitForm);
    $(document).on("change", "#filter_academic_year", submitForm);

    $("#main_filter_form").on("ajax:success", () => Shared.setTableHeight());
  };

  this.setSelects = () => {
    const form = document.getElementById("main_filter_form");

    $("#filter_school_id").select2({
      placeholder: "Select school",
      allowClear: false,
    });

    $("#filter_education_level").select2({
      minimumResultsForSearch: Infinity,
    });

    $("#filter_expectation").select2({
      minimumResultsForSearch: Infinity,
    });

    $("#filter_subject").select2({
      allowClear: false,
      dropdownParent: $("#filter_subject").closest("div"),
      ajax: {
        dataType: "json",
        url: "/subject_entities/autocomplete",
        delay: 250,
        data: (params) => ({
          ...params,
          current_year: form["filter[academic_year]"]?.value,
          school_id: form["filter[school_id]"]?.value,
        }),
      },
    });

    $("#filter_student_id").select2({
      placeholder: "Any student",
      ajax: {
        dataType: "json",
        url: "/student_entities/autocomplete",
        delay: 250,
        data: (params) => ({
          ...params,
          school_id: form["filter[school_id]"]?.value,
          subject: form["filter[subject]"]?.value,
          current_year: form["filter[academic_year]"]?.value,
          tutor_group_id: form["filter[tutor_group_id]"]?.value,
        }),
      },
    });

    $("#filter_teacher_id").select2({
      placeholder: "Any teacher",
      ajax: {
        dataType: "json",
        url: "/teacher_entities/autocomplete",
        delay: 250,
        data: (params) => ({
          ...params,
          school_id: form["filter[school_id]"]?.value,
          subject: form["filter[subject]"]?.value,
          current_year: form["filter[academic_year]"]?.value,
        }),
      },
    });

    $("#filter_tutor_group_id").select2({
      placeholder: "Any tutor group",
      ajax: {
        dataType: "json",
        url: `/tutor_groups/autocomplete`,
        delay: 250,
        data: (params) => ({
          ...params,
          school_id: form["filter[school_id]"]?.value,
          subject: form["filter[subject]"]?.value,
          current_year: form["filter[academic_year]"]?.value,
        }),
      },
    });

    $(form).on("change", function (e) {
      if (e.target.name === "filter[academic_year]" || e.target.closest("#subject_teacher--filter")) {
        const previousYearsFilter = document.getElementById("previous_years--filter");
        if (!previousYearsFilter) return;

        const academicYear = form["filter[academic_year]"]?.value;
        for (let option of previousYearsFilter.querySelectorAll("option")) {
          if (Boolean(academicYear) && option.value <= academicYear) {
            option.setAttribute("selected", "");
          } else {
            option.removeAttribute("selected");
          }
        }
        previousYearsFilter.dispatchEvent(new Event("change"));
      }
    });
  };

  this.bindInClassCheckbox = () => {
    $(document).on("change", "input.is-in-class", function () {
      $("form.filter-form input#filter_is_in_class").val($("input.is-in-class").is(":checked"));
      submitForm();
    });
  };

  this.bindShowInClass = () => {
    $(document).on("click", "input.graph_show_in_class", function () {
      let chartRow = $(this).closest("tr");
      let chartContainerId = $(chartRow).find(".chartContainer").attr("id");
      let formData = $("#main_filter_form").serializeArray();
      let isInClass = "false";

      if ($(this).is(":checked")) {
        isInClass = "true";
      }

      formData.forEach((form, index) => {
        if (form.name === "filter[is_in_class]") {
          formData[index].value = isInClass;
        }
      });

      MainTable.buildChart(chartContainerId, formData);
    });
  };

  this.showIntroResults = () => {
    $(document).on("change", "#show_intro_results-id", function () {
      $("#filter_show_intro_results").val($("#show_intro_results-id").is(":checked"));
      submitForm();
    });
  };

  this.bindSubjectYearSelect = () => {
    $(document).on("change", "#subject_teacher--filter", function () {
      $(".filter_individual_result").remove();
      submitForm();
    });
  };
})();
